module.exports = __webpack_public_path__ + "static/media/overlord-helm.03e5b513.svg";